import { render, staticRenderFns } from "./CriticaDespesasSemEmpresa.vue?vue&type=template&id=53d47e09&scoped=true"
import script from "./CriticaDespesasSemEmpresa.vue?vue&type=script&lang=js"
export * from "./CriticaDespesasSemEmpresa.vue?vue&type=script&lang=js"
import style0 from "./CriticaDespesasSemEmpresa.vue?vue&type=style&index=0&id=53d47e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d47e09",
  null
  
)

export default component.exports